/* -----------------Globals--------------- */
import { Stack, useLocalSearchParams } from "expo-router";

/* -----------------Child components--------------- */
import Box from "@memorang/ui/components/Box";
import ScrollContainer from "@memorang/ui/components/ScrollContainer";
import { useDevice } from "@memorang/ui/useDevice";
import CustomMarkdownRenderer from "components/CustomMarkdownRenderer";
import ModalHeader from "components/ModalHeader";

const InfoModal = () => {
	const { title, body } = useLocalSearchParams<{
		title: string;
		body: string;
	}>();
	const { isMobileWeb } = useDevice();

	return (
		<>
			<Stack.Screen
				options={{
					presentation: "modal",
					headerShown: true,
					header: () => (
						<ModalHeader backIcon="arrow-left" headerTitle={title || ""} />
					),
				}}
			/>
			<Box flex={1}>
				{isMobileWeb && (
					<ModalHeader backIcon="arrow-left" headerTitle={title || ""} />
				)}
				<ScrollContainer>
					<Box padding={16}>
						<CustomMarkdownRenderer text={body} />
					</Box>
				</ScrollContainer>
			</Box>
		</>
	);
};

export default InfoModal;
